import { makeStyles } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import useText from "constants/text";
import { BackButton, ExitText } from "domains/Request/component/shared/MainStyles";
import React from "react";
import { createStyles } from "@material-ui/core/styles";
import { theme } from "config/theme";

const useStyles = makeStyles(() =>
  createStyles({
    arrow: {
      textAlign: "center",
      marginLeft: "1vw",
      fontSize: "1.3rem",
      [theme.breakpoints.down("xs")]: {
        textAlign: "center",
        marginLeft: "1vw",
        fontSize: "1rem",
      },
    },
  })
);
interface IBButtonWithIcon {
  onClick: () => void;
  className?: string;
}

export const QuitButton = ({ onClick }: IBButtonWithIcon) => {
  const { text } = useText();
  const styles = useStyles()
  return (
    <BackButton onClick={onClick}>
      <ArrowBackIosIcon className={styles.arrow} />
      <ExitText>{text.all.quit}</ExitText>
    </BackButton>
  );
};
